/*
  Zenino: livrare estimata, fara aplicatie.
  Inlocuieste "Estimated Delivery Days" (SetuBridge). Regulile (tag-uri 1-3, 3-5, 5-7, 7-9,
  ora limita, sarbatori) vin din snippet-ul zn-delivery-data.liquid si se pot edita acolo.

  Ce face:
  1. Calculeaza intervalul de livrare in zile lucratoare, in ora Romaniei.
  2. Il afiseaza in pagina de produs, sub butonul de cumparare (.delivery_date_shortcode).
  3. Pune pe fiecare formular de adaugare in cos proprietatea "Estimat de livrare",
     exact cu acelasi nume si format ca pana acum ("mie, 14 oct - vin, 16 oct"),
     ca sa apara la fel in cos, in comenzi si in emailuri.
*/
(function (root, factory) {
  var api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  else root.znDelivery = api;
  if (typeof document !== 'undefined') api.boot();
})(typeof self !== 'undefined' ? self : this, function () {
  'use strict';

  var DAY = 86400000;
  var WEEKDAYS_EN = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
  var WEEKDAYS_RO = ['dum', 'lun', 'mar', 'mie', 'joi', 'vin', 'sâm'];
  var MONTHS_RO = ['ian', 'feb', 'mar', 'apr', 'mai', 'iun', 'iul', 'aug', 'sep', 'oct', 'nov', 'dec'];

  function pad(n) { return n < 10 ? '0' + n : '' + n; }

  /* "Ora de perete" a magazinului, tinuta ca timestamp UTC. Toate calculele folosesc componente UTC,
     deci nu depind de fusul orar al vizitatorului. */
  function parseWall(str) {
    var m = /^(\d{4})-(\d{2})-(\d{2})[T ](\d{2}):(\d{2})(?::(\d{2}))?/.exec(str || '');
    if (!m) return NaN;
    return Date.UTC(+m[1], +m[2] - 1, +m[3], +m[4], +m[5], +(m[6] || 0));
  }

  function midnight(ts) {
    var d = new Date(ts);
    return Date.UTC(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate());
  }

  function isHoliday(ts, holidays) {
    var d = new Date(ts);
    var md = pad(d.getUTCMonth() + 1) + '-' + pad(d.getUTCDate());
    var full = d.getUTCFullYear() + '-' + md;
    for (var i = 0; i < holidays.length; i++) {
      if (holidays[i] === md || holidays[i] === full) return true;
    }
    return false;
  }

  function isOffDay(ts, offDays, holidays) {
    return offDays.indexOf(WEEKDAYS_EN[new Date(ts).getUTCDay()]) !== -1 || isHoliday(ts, holidays);
  }

  /*
    Intervalul pentru o regula. Pasii, in aceeasi ordine ca la aplicatia veche:
    - dupa ora limita (sau intr-o zi nelucratoare) comanda se proceseaza abia in prima zi lucratoare;
    - se numara zilele lucratoare (sambata, duminica si sarbatorile regulii nu conteaza);
    - data finala nu poate cadea intr-o zi in care nu se livreaza.
  */
  function compute(nowTs, rule, cfg) {
    var today = midnight(nowTs);
    var holidays = rule.holidays || [];
    var weekoff = cfg.weekoff;
    var deliveryOff = cfg.deliveryOff;

    var afterCutoff = false;
    if (rule.cutoff) {
      var hm = rule.cutoff.split(':');
      var cutoffTs = today + (+hm[0]) * 3600000 + (+hm[1]) * 60000;
      afterCutoff = !(nowTs < cutoffTs);
    }
    var todayIsOff = isOffDay(today, weekoff, holidays);
    var cutoffApplies = afterCutoff && !todayIsOff;

    function lead(n) {
      var d = today + (cutoffApplies ? DAY : 0);
      var guard = 0;
      for (var k = 1; k <= n && k <= 1000; k++) {
        if (isOffDay(d, weekoff, holidays)) n++;
        d += DAY;
      }
      if (cutoffApplies) n++;
      var result = today + n * DAY;
      while (isOffDay(result, deliveryOff, holidays) && guard++ < 1000) result += DAY;
      return result;
    }
    return { min: lead(rule.min), max: lead(rule.max) };
  }

  function format(ts) {
    var d = new Date(ts);
    return WEEKDAYS_RO[d.getUTCDay()] + ', ' + pad(d.getUTCDate()) + ' ' + MONTHS_RO[d.getUTCMonth()];
  }

  /*
    Starea de stoc, ca la aplicatia veche:
    cantitate > 0 -> 1 (in stoc);  cantitate <= 0 si indisponibil -> 3 (fara stoc);
    cantitate <= 0 dar se poate comanda mai departe -> 0.
    Regulile "in stoc" (1) se aplica doar la 1. Regulile "oricand" ('any') se aplica la toate starile.
  */
  function stockState(variant) {
    var qty = variant.qty;
    if (qty > 0) return 1;
    if (variant.available === false) return 3;
    return 0;
  }

  function pickRule(tags, state, cfg) {
    var i, j, r;
    for (i = 0; i < tags.length; i++) {
      for (j = 0; j < cfg.tagRules.length; j++) {
        r = cfg.tagRules[j];
        if (r.tag.toLowerCase() === String(tags[i]).toLowerCase() && (r.stock === 'any' || (r.stock === 'in' && state === 1))) return r;
      }
    }
    var d = cfg.defaultRule;
    if (d && (d.stock === 'any' || (d.stock === 'in' && state === 1))) return d;
    /* Niciuna din regulile de mai sus nu se potriveste (ex. produs fara stoc, fara tag de livrare):
       se aplica mesajul general, ca la aplicatia veche. */
    return cfg.fallbackRule || null;
  }

  function estimate(nowTs, tags, variant, cfg) {
    var rule = pickRule(tags, stockState(variant), cfg);
    if (!rule) return null;
    var r = compute(nowTs, rule, cfg);
    return { rule: rule, label: rule.label || cfg.label, min: r.min, max: r.max, minText: format(r.min), maxText: format(r.max) };
  }

  /* ---------- Browser ---------- */

  function storeNow(data) {
    var server = parseWall(data.now);
    var loaded = window.__znDeliveryT0;
    var elapsed = typeof performance !== 'undefined' ? performance.now() - loaded : 0;
    var serverNow = server + elapsed;
    try {
      var parts = new Intl.DateTimeFormat('en-GB', {
        timeZone: data.config.timezone, hourCycle: 'h23',
        year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit'
      }).formatToParts(new Date());
      var p = {};
      parts.forEach(function (x) { p[x.type] = x.value; });
      var device = Date.UTC(+p.year, +p.month - 1, +p.day, +p.hour, +p.minute, +p.second);
      /* Daca pagina vine dintr-un cache vechi, ceasul dispozitivului e mai proaspat.
         Daca ceasul dispozitivului e gresit cu mult, ramane ora serverului. */
      if (Math.abs(device - serverNow) < 30 * 60000) return device;
    } catch (e) { /* ramane ora serverului */ }
    return serverNow;
  }

  function readData() {
    var el = document.getElementById('zn-delivery-data');
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  function currentVariant(data, forcedId) {
    var id = forcedId ? String(forcedId) : null;
    if (!id) {
      var input = document.querySelector('form[action*="/cart/add"] [name="id"]');
      if (input && input.value) id = String(input.value);
    }
    if (!id) id = String(data.selected);
    for (var i = 0; i < data.variants.length; i++) {
      if (String(data.variants[i].id) === id) return data.variants[i];
    }
    return data.variants[0];
  }

  function el(tag, attrs, html) {
    var n = document.createElement(tag);
    if (attrs) for (var k in attrs) n.setAttribute(k, attrs[k]);
    if (html != null) n.innerHTML = html;
    return n;
  }

  /* Pe pagina de produs: "Livrare estimata: mie, 14 oct – joi, 15 oct", sub butonul de cumparare.
     In romana pastram formatul aplicatiei vechi; in alte limbi, zilele si lunile vin din browser. */
  function displayDate(ts, locale) {
    if (!locale || /^ro/i.test(locale)) return format(ts);
    try {
      return new Intl.DateTimeFormat(locale, { weekday: 'short', day: 'numeric', month: 'short', timeZone: 'UTC' }).format(new Date(ts));
    } catch (e) {
      return format(ts);
    }
  }

  function render(container, est, data) {
    container.textContent = '';
    if (!est) return;
    var display = data.display || {};
    var label = el('span', { 'class': 'zn-ship__label' });
    label.textContent = (display.label || est.label) + ' ';
    var from = el('strong');
    from.textContent = displayDate(est.min, display.locale);
    var to = el('strong');
    to.textContent = displayDate(est.max, display.locale);
    container.appendChild(label);
    container.appendChild(from);
    container.appendChild(document.createTextNode(' – '));
    container.appendChild(to);
  }

  function syncInputs(est, cfg) {
    var forms = document.querySelectorAll('form[action*="/cart/add"]');
    var name = 'properties[' + cfg.label + ']';
    for (var i = 0; i < forms.length; i++) {
      /* Produsele din "Cumparate frecvent impreuna" nu primeau proprietatea la aplicatia veche: le sarim. */
      if (forms[i].closest && forms[i].closest('.zn-upsell')) continue;
      var inp = forms[i].querySelector('input[data-zn-delivery-property]');
      if (!est) { if (inp) inp.remove(); continue; }
      if (!inp) {
        inp = document.createElement('input');
        inp.type = 'hidden';
        inp.name = name;
        inp.setAttribute('data-zn-delivery-property', '');
        forms[i].appendChild(inp);
      }
      inp.value = est.minText + ' - ' + est.maxText;
    }
  }

  function boot() {
    if (window.__znDeliveryBooted) return;
    window.__znDeliveryBooted = true;
    window.__znDeliveryT0 = typeof performance !== 'undefined' ? performance.now() : 0;
    var data = readData();
    if (!data) return;
    var cfg = data.config;
    var container = document.querySelector('.delivery_date_shortcode');

    function update(forcedId) {
      var est = estimate(storeNow(data), data.tags, currentVariant(data, forcedId), cfg);
      if (container) render(container, est, data);
      syncInputs(est, cfg);
      return est;
    }
    update();
    document.addEventListener('on:variant:change', function (e) {
      update(e && e.detail && e.detail.variant ? e.detail.variant.id : null);
    });
    document.addEventListener('change', function (e) {
      if (e.target && e.target.matches && e.target.matches('form[action*="/cart/add"] [name="id"]')) update();
    });
    /* Chiar inainte de trimiterea formularului: data poate sa se fi schimbat daca pagina a stat deschisa. */
    document.addEventListener('submit', function (e) {
      if (e.target && e.target.matches && e.target.matches('form[action*="/cart/add"]')) update();
    }, true);
    /* Reface mesajul daca tema reinnoieste continutul paginii (ex. cand trecem la alta varianta cu schimbare de sectiune). */
    var obs = new MutationObserver(function () {
      var c = document.querySelector('.delivery_date_shortcode');
      if (c && c !== container) { container = c; update(); }
    });
    obs.observe(document.body, { childList: true, subtree: true });
  }

  return { compute: compute, estimate: estimate, format: format, parseWall: parseWall, stockState: stockState, pickRule: pickRule, boot: boot };
});
